import { defineMessages } from "../core"

export const chat = defineMessages({
  en: {
    "attachment.uploading": "Uploading {filename}…",
    "attachment.dismiss": "Dismiss",
    "attachment.remove": "Remove attachment",

    "thread.example1": "What documents do we have about onboarding?",
    "thread.example2": "Summarize the latest project status report",
    "thread.example3": "Which guidelines exist for Azure best practices?",
    "thread.hello": "Hello!",
    "thread.helloName": "Hello, {name}!",
    "thread.newChatInProject": "New chat in “{project}”.",
    "thread.askAnything": "Ask {title} anything.",

    "composer.clearAgent": "Clear agent",
    "composer.uploadFile": "Upload file",
    "composer.uploadFailed": "Upload failed ({filename})",
    "composer.placeholderWorkIq": "Ask about your documents, mail, chats and meetings…",
    "composer.placeholderAgent": "Asking {agent}…",
    "composer.placeholderDefault": "Ask about your SharePoint documents…",
    "composer.stop": "Stop generating",
    "composer.sendMessage": "Send message",
    "composer.send": "Send",
    "composer.disclaimer": "celver Copilot can make mistakes — verify important information.",

    "effort.label": "Effort",
    "effort.aria": "Reasoning effort",

    "message.imageFailed": "⚠️ Image could not be loaded.",
    "message.openImage": "Open image",
    "message.generatedImage": "Generated image",
    "message.openFullSize": "Click to open full size",
    "message.copyAnswer": "Copy answer",
    "message.copied": "Copied",
    "message.searching": "Searching {target}…",
    "message.generatingImage": "Generating image…",
    "message.error": "Sorry, I encountered an error. Please try again.",
    "message.answeredWith": "Answered with",
    "message.lowConfidence":
      "I couldn't find a strong match for this question. Try rephrasing, using different keywords, or check if the document exists in SharePoint.",

    "model.select": "Select model",
    "model.current": "Model: {model}",
    "model.label": "Model",

    "project.select": "Select project for this chat",
    "project.current": "Project: {name}",
    "project.add": "Add this chat to a project",
    "project.none": "No project",
    "project.label": "Project",

    "retrieval.label": "Retrieval",
    "retrieval.aria": "Retrieval engine",

    "scope.aria": "Search scope",
    "scope.sharepoint": "SharePoint",
    "scope.sharepointTitle": "Search the SharePoint documents.",
    "scope.mail": "Mail",
    "scope.mailTitle": "Also search your own Outlook mail. Only you can see these results.",
    "scope.teams": "Teams",
    "scope.teamsTitle": "Also search your own Teams chats. Only you can see these results.",

    "sources.title": "SOURCES",
    "sources.mixed": "Documents, mail and chats",
    "sources.grounded": "Grounded in your documents",
    "sources.openNewTab": "Open in new tab",
    "sources.siteHint": "Sites / {name}",

    "markdown.document": "Document",
    "markdown.sourceLabel": "Source {n}: {title}",
  },
  de: {
    "attachment.uploading": "{filename} wird hochgeladen…",
    "attachment.dismiss": "Schließen",
    "attachment.remove": "Anhang entfernen",

    "thread.example1": "Welche Dokumente haben wir zum Onboarding?",
    "thread.example2": "Fasse den neuesten Projektstatusbericht zusammen",
    "thread.example3": "Welche Richtlinien gibt es für Azure Best Practices?",
    "thread.hello": "Hallo!",
    "thread.helloName": "Hallo, {name}!",
    "thread.newChatInProject": "Neuer Chat im Projekt „{project}“.",
    "thread.askAnything": "Frag {title}.",

    "composer.clearAgent": "Agent entfernen",
    "composer.uploadFile": "Datei hochladen",
    "composer.uploadFailed": "Upload fehlgeschlagen ({filename})",
    "composer.placeholderWorkIq": "Frag zu deinen Dokumenten, Mails, Chats und Meetings…",
    "composer.placeholderAgent": "Frage an {agent}…",
    "composer.placeholderDefault": "Frag zu deinen SharePoint-Dokumenten…",
    "composer.stop": "Generierung stoppen",
    "composer.sendMessage": "Nachricht senden",
    "composer.send": "Senden",
    "composer.disclaimer": "celver Copilot kann Fehler machen – bitte wichtige Informationen prüfen.",

    "effort.label": "Aufwand",
    "effort.aria": "Denkaufwand",

    "message.imageFailed": "⚠️ Das Bild konnte nicht geladen werden.",
    "message.openImage": "Bild öffnen",
    "message.generatedImage": "Generiertes Bild",
    "message.openFullSize": "Klicken, um in voller Größe zu öffnen",
    "message.copyAnswer": "Antwort kopieren",
    "message.copied": "Kopiert",
    "message.searching": "{target} wird durchsucht…",
    "message.generatingImage": "Bild wird generiert…",
    "message.error": "Entschuldigung, es ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    "message.answeredWith": "Beantwortet mit",
    "message.lowConfidence":
      "Ich habe keinen guten Treffer zu dieser Frage gefunden. Formuliere die Frage um, verwende andere Stichwörter oder prüfe, ob das Dokument in SharePoint existiert.",

    "model.select": "Modell auswählen",
    "model.current": "Modell: {model}",
    "model.label": "Modell",

    "project.select": "Projekt für diesen Chat auswählen",
    "project.current": "Projekt: {name}",
    "project.add": "Diesen Chat zu einem Projekt hinzufügen",
    "project.none": "Kein Projekt",
    "project.label": "Projekt",

    "retrieval.label": "Suche",
    "retrieval.aria": "Suchmaschine",

    "scope.aria": "Suchbereich",
    "scope.sharepoint": "SharePoint",
    "scope.sharepointTitle": "Die SharePoint-Dokumente durchsuchen.",
    "scope.mail": "Mail",
    "scope.mailTitle": "Zusätzlich deine eigenen Outlook-Mails durchsuchen. Nur du siehst diese Ergebnisse.",
    "scope.teams": "Teams",
    "scope.teamsTitle": "Zusätzlich deine eigenen Teams-Chats durchsuchen. Nur du siehst diese Ergebnisse.",

    "sources.title": "QUELLEN",
    "sources.mixed": "Dokumente, Mails und Chats",
    "sources.grounded": "Basiert auf deinen Dokumenten",
    "sources.openNewTab": "In neuem Tab öffnen",
    "sources.siteHint": "Sites / {name}",

    "markdown.document": "Dokument",
    "markdown.sourceLabel": "Quelle {n}: {title}",
  },
})
